import React from "react";
import ReactDOM from "react-dom";
import App from "./app/App";
import "./assets/css/additional.css";
import "./assets/css/dashmix.css";
import "./assets/css/themes/xwork.min.css";
ReactDOM.render(<App />, document.getElementById("root"));
